import styled, { css } from 'styled-components';

interface StyledEditableDescriptionProps {
    $focused?: boolean;
}

export const StyledEditableDescription = styled.div<StyledEditableDescriptionProps>`
    &&& {
        --yat_editable-text-area-font-family: 'Alliance No.1';
        --yat_editable-text-area-font-size: 16px;
        --yat_editable-text-area-font-weight: 600;
        --yat_editable-text-area-letter-spacing: -0.03em;
        --yat_editable-text-area-line-height: 1.2;
        --yat_editable-text-area-color: ${({ theme }) => theme.shades.white['50']};
        --yat_editable-text-area-placeholder-color: ${({ theme }) => theme.shades.white['35']};
        --yat_editable-text-area-shadow: 0 0 15px ${({ theme }) => theme.shades.white['50']},
            0 0 20px ${({ theme }) => theme.colors.purple};
        --yat_editable-text-area-padding: 10px;
        --yat_editable-text-area-radius: 10px;

        &:hover {
            --yat_editable-text-area-bg-color: ${({ theme }) => theme.shades.white['5']};
        }

        &:active {
            --yat_editable-text-area-bg-color: ${({ theme }) => theme.shades.white['10']};
        }

        // TODO: Revisit these styles:

        // 1. Arbitrary maximum width for text description.
        max-width: 500px;

        // 2. Leave room for the remaining characters indicator.
        @media (min-width: 480px) and (max-width: 767px) {
            margin-right: 55px;
        }

        ${({ $focused }) =>
            $focused &&
            css`
                position: relative;
                z-index: 6;
            `};
    }
`;
